import type { PortalBackInStockTextPromptDto } from '@supply-mover-2-0/shared';
import { create } from 'zustand';

interface BackInStockTextPromptState {
	/** The question to show, or null when none is open. */
	prompt: PortalBackInStockTextPromptDto | null;
	open: (prompt: PortalBackInStockTextPromptDto) => void;
	close: () => void;
}

/**
 * PD-14306 — the one-time "also text me?" question asked after a customer's
 * first "Notify me". A store (like `useNotificationTrayStore`) because the
 * control that triggers it sits inside a product card, and the dialog is
 * rendered once by the layout: a catalog page has dozens of those controls,
 * and each mounting its own dialog would stack one per click.
 */
export const useBackInStockTextPromptStore = create<BackInStockTextPromptState>(
	(set) => ({
		prompt: null,
		open: (prompt): void => {
			set({ prompt });
		},
		close: (): void => {
			set({ prompt: null });
		},
	}),
);
